
export const retrieveCreateTable = () => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      resolve(getState().create_Table);
    })
  }
}
